import type { JSX } from "preact";
import { Link } from "@gss/components/icons";
import { useTranslation } from "../util/Translation";

export function MultiSelectionDesc(): JSX.Element {
    const t = useTranslation().translation.filters;
    return (
        <>
            <Link aria-hidden /> {t.multiSelectionDesc1}
            <ol>
                <li>{t.multiSelectionDesc2}</li>
                <li>{t.multiSelectionDesc3}</li>
                <li>{t.multiSelectionDesc4}</li>
            </ol>
        </>
    );
}
